import React from "react";
import classnames from "classnames/bind";
import { alpha3ToAlpha2 } from "i18n-iso-countries";

import styles from "./index.module.scss";

import localesReplacement from "../../../utils/localesReplacement";
import { Replacement } from "../../../interface";

import { FOOTER_LINKS } from "../../../constants/variants";

const cx = classnames.bind(styles);

interface IProps {
  country: string;
  replacements: Replacement;
}

const Footer = (props: IProps) => {
  const { country, replacements } = props;
  const lastModified = Date.parse(
    process.env.REACT_APP_FORD_MODIFIED_DATE || "17 Jun 2024"
  );

  const links = FOOTER_LINKS[country] ?? FOOTER_LINKS["GBR"];

  const countryCode = alpha3ToAlpha2(country);
  const locale = `en-${countryCode}`;

  const lastModifiedLocalized = new Intl.DateTimeFormat(locale, {
    dateStyle: "short",
  }).format(lastModified);

  return (
    <nav>
      <ul className={cx("footer")}>
        <li>
          <a href={links.home}>{localesReplacement(replacements, "Home")}</a>
        </li>
        <li>
          <a href={links.contact}>
            {localesReplacement(replacements, "Contact")}
          </a>
        </li>
        <li>
          <a href={links.legal}>
            {localesReplacement(replacements, "Legal Notice")}
          </a>
        </li>
        <li>
          <a href={links.privacy}>
            {localesReplacement(replacements, "Privacy Policy")}
          </a>
        </li>
        {lastModified && (
          <li>
            <a>
              <span>{localesReplacement(replacements, "Last Modified")}</span>
              <span>{lastModifiedLocalized} </span>
            </a>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Footer;
